import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { Flame } from "lucide-react";
import { Link } from "react-router";
import { api, type HotPromoItem } from "@/api";
import { ProductCard } from "@/components/product/product-card";
import { expandProductTiles } from "@/lib/product-tiles";
import { PromoCountdown } from "./countdown";
import { promoPrice } from "./promo-price";

// Блок «Горящие акции» на главной (П3, fd-promo-10): товары идущих сейчас
// горящих акций, у кого акция кончается раньше — тот первый. На карточке —
// таймер и цена со скидкой; по нулю таймера карточка уходит из блока.
// Нет горящих акций — блока нет совсем, пустой заголовок не рисуем.

const RAIL_CLASS = "-mx-4 flex snap-x scroll-px-4 gap-2 overflow-x-auto px-4 pb-1 sm:gap-2.5 md:mx-0 md:scroll-px-0 md:px-0 lg:gap-5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden";

/** Плитка карточки с ценой акции: показ, расчёт заказа — на шлюзе. */
const promoTile = (item: HotPromoItem) => {
  const tile = expandProductTiles([item.product])[0];
  if (!tile) return undefined;
  const {
    discountType,
    discountValue
  } = item.promo;
  const price = promoPrice(tile.price, discountType, discountValue);
  return {
    ...tile,
    price,
    oldPrice: Math.max(tile.oldPrice ?? 0, tile.price)
  };
};
export function HotPromos() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["promos", "hot"],
      queryFn: _temp,
      refetchInterval: 60000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== query) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = (query.data ?? []).filter(_temp2);
      if (items.length === 0) {
        t6 = null;
        break bb0;
      }
      t3 = "flex flex-col gap-2.5";
      t4 = "home-hot-promos";
      if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div className="flex items-end justify-between gap-4"><div className="flex flex-col sm:gap-1.5"><h2 className="flex items-center gap-1.5 text-[16px] font-normal leading-5 text-[#1F1F1F] sm:text-[20px] sm:font-semibold sm:leading-[23px]"><Flame className="size-5 text-osmix-tangelo" aria-hidden={true} />Горящие акции</h2><p className="text-[12px] leading-4 text-[#1F1F1F] sm:text-[16px] sm:leading-5">Скидки на сутки - успейте</p></div><Link to="/promos?kind=flash" className="shrink-0 text-[14px] leading-5 text-osmix-text-2 transition-colors hover:text-osmix-tangelo">Все акции</Link></div>;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t1 = RAIL_CLASS;
      t2 = items.map(item_0 => {
        const tile = promoTile(item_0);
        return <div key={`${item_0.promo.id}-${item_0.product.id}`} className="relative w-[166px] shrink-0 snap-start sm:w-[173px]"><ProductCard product={item_0.product} tile={tile} variant="rail" /><PromoCountdown endsAt={item_0.promo.endsAt} label="" onExpire={() => void query.refetch()} className="pointer-events-none absolute left-2 top-2" /></div>;
      });
    }
    $[1] = query;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t7) {
    t8 = <section className={t3} data-testid={t4}>{t5}{t7}</section>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp2(item) {
  return Date.parse(item.promo.endsAt) > Date.now();
}
function _temp() {
  return api.promos.hot(24);
}